// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as K2ExerciseInSeriesContainer$LiteracyplanetTupperware from "../v2/K2ExerciseInSeriesContainer.res.mjs";

function PilotfulLayoutContainer(props) {
  V2ExerciseContext$LiteracyplanetTupperware.use();
  return React.createElement(React.Fragment, {}, React.createElement("link", {
                  href: "https://use.typekit.net/hzt6ypm.css",
                  rel: "stylesheet"
                }), React.createElement(K2ExerciseInSeriesContainer$LiteracyplanetTupperware.make, {
                  questionCount: props.questionCount,
                  children: props.children
                }));
}

var make = PilotfulLayoutContainer;

var $$default = PilotfulLayoutContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
